// Portfolio.tsx
import React, { memo } from "react";
import { Container } from "./styles";
import githubIcon from "../../assets/github-icon.svg";
import ScrollAnimation from "react-animate-on-scroll";

type Project = {
  title: string;
  description?: string;
  tech?: string[];
  github?: string;
  image?: string;
  demo?: string;
};
const projects: Project[] = [
  {
    title: "Updating Soon",
    description: "Check back shortly for new projects.",
  },
];

// Minimal component so Main.tsx keeps working
export function Portfolio() {
  return (
    <Container id="portfolio">
      <h2>Projects</h2>
      <div className="projects">
        {projects.map((p) => (
          <div
            className="project"
            key={p.title}
            role="article"
            aria-labelledby={`title-${p.title}`}
          >
            <div className="body">
              <h3 id={`title-${p.title}`}>{p.title}</h3>
              {p.description && <p>{p.description}</p>}
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}

// const projects: Project[] = [
//   {
//     title: "Updating Soon",
//     // description:
//     //   "Users register, create a profile, search for friends, create posts, message friends, comment and like posts from friends. React, Node, Express, Vite, MongoDB.",
//     // tech: ["React", "Node", "MongoDB"],
//     // github: "https://github.com/SarahSchoonmaker/petpal",
//     // image: require("../../assets/petpal.png"),
//   },
//   {
//     title: "Pizza Shop",
//     description:
//       "A full-stack food ordering app built with Next.js 14 (React.js, MongoDB, Tailwind CSS).",
//     tech: ["React", "Next.js", "MongoDB"],
//     github: "https://github.com/SarahSchoonmaker/pizza-shop-react",
//     image: require("../../assets/pizza.png"),
//   },
//   {
//     title: "E-Commerce store built with Django and React",
//     github: "https://github.com/SarahSchoonmaker/django-react-ecommerce.git",
//     image: require("../../assets/ecommerce.png"),
//   },
// ];

// const ProjectCard = memo(function ProjectCard({
//   project,
// }: {
//   project: Project;
// }) {
//   const titleId = `title-${project.title.replace(/\s+/g, "-").toLowerCase()}`;
//   const descId =
//     project.description &&
//     `desc-${project.title.replace(/\s+/g, "-").toLowerCase()}`;

//   return (
//     <div
//       className="project"
//       role="article"
//       aria-labelledby={titleId}
//       {...(descId ? { "aria-describedby": descId } : {})}
//     >
//       <header>
//         <svg
//           width="50"
//           xmlns="http://www.w3.org/2000/svg"
//           role="img"
//           viewBox="0 0 24 24"
//           fill="none"
//           stroke="#23ce6b"
//           strokeWidth="1"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           aria-label="Project folder icon"
//         >
//           <title>Folder</title>
//           <path d="M22 19a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5l2 3h9a2 2 0 0 1 2 2z" />
//         </svg>

//         <div className="project-links">
//           {project.github && (
//             <a
//               href={project.github}
//               target="_blank"
//               rel="noopener noreferrer"
//               aria-label={`View ${project.title} on GitHub`}
//               title="GitHub"
//             >
//               <img src={githubIcon} alt="" />
//             </a>
//           )}
//           {project.demo && (
//             <a
//               href={project.demo}
//               target="_blank"
//               rel="noopener noreferrer"
//               className="demo-link"
//               aria-label={`Open demo of ${project.title}`}
//             >
//               Demo
//             </a>
//           )}
//         </div>
//       </header>

//       <div className="body">
//         <h3 id={titleId}>{project.title}</h3>

//         {project.description ? (
//           <p id={descId!}>
//             {project.description}{" "}
//             {project.github && (
//               <a
//                 href={project.github}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 View on GitHub
//               </a>
//             )}
//           </p>
//         ) : (
//           // If there's no description but there IS a GitHub link, still show something useful
//           project.github && (
//             <p>
//               <a
//                 href={project.github}
//                 target="_blank"
//                 rel="noopener noreferrer"
//               >
//                 View on GitHub
//               </a>
//             </p>
//           )
//         )}
//       </div>

//       <footer>
//         {project.tech?.length ? (
//           <ul className="tech-list" aria-label="Technologies used">
//             {project.tech.map((t, i) => (
//               <li key={`${t}-${i}`}>{t}</li>
//             ))}
//           </ul>
//         ) : null}

//         {project.image && (
//           <div className="project-image">
//             <img
//               src={project.image}
//               alt={`${project.title} preview`}
//               loading="lazy"
//               decoding="async"
//             />
//           </div>
//         )}
//       </footer>
//     </div>
//   );
// });

// export function Portfolio() {
//   return (
//     <Container id="portfolio">
//       <h2>Projects</h2>
//       <div className="projects">
//         {projects.map((p) => (
//           <ScrollAnimation key={p.title} animateIn="flipInX">
//             <ProjectCard project={p} />
//           </ScrollAnimation>
//         ))}
//       </div>
//     </Container>
//   );
// }
